module.exports = __webpack_public_path__ + "static/media/joker-hited.44362551.png";